import { buildResourceHeaderProps as approverBuildResourceHeaderProps } from 'modules/planning/roles/approver/resourceHeader'
import { getColumnDefinition as approverGetColumnDefinition } from 'modules/planning/roles/approver/columnDefinition'
import { buildResourceHeaderProps as creatorBuildResourceHeaderProps } from 'modules/planning/roles/creator/resourceHeader'
import { getColumnDefinition as creatorGetColumnDefinition } from 'modules/planning/roles/creator/columnDefinition'
import { buildResourceHeaderProps as editorBuildResourceHeaderProps } from 'modules/planning/roles/editor/resourceHeader'
import { getColumnDefinition as editorGetColumnDefinition } from 'modules/planning/roles/editor/columnDefinition'
import { buildResourceHeaderProps as globalEditorBuildResourceHeaderProps } from 'modules/planning/roles/global_editor/resourceHeader'
import { getColumnDefinition as globalEditorGetColumnDefinition } from 'modules/planning/roles/global_editor/columnDefinition'
import { buildResourceHeaderProps as globalViewerBuildResourceHeaderProps } from 'modules/planning/roles/global_viewer/resourceHeader'
import { getColumnDefinition as globalViewerGetColumnDefinition } from 'modules/planning/roles/global_viewer/columnDefinition'
import { buildResourceHeaderProps as ownerBuildResourceHeaderProps } from 'modules/planning/roles/owner/resourceHeader'
import { getColumnDefinition as ownerGetColumnDefinition } from 'modules/planning/roles/owner/columnDefinition'
import { buildResourceHeaderProps as viewerBuildResourceHeaderProps } from 'modules/planning/roles/viewer/resourceHeader'
import { getColumnDefinition as viewerGetColumnDefinition } from 'modules/planning/roles/viewer/columnDefinition'

import type {
  PeriodDetailData,
  PeriodRoleContext,
} from 'modules/planning/roles/base/resourceHeader'
import type { HeadcountColumn } from 'modules/planning/roles/base/columnDefinition'
import type { ResourceHeadersPropsWithActions } from 'modules/core/lib/navigation/types'

export type { PeriodRoleContext } from 'modules/planning/roles/base/resourceHeader'

type ResourceHeaderBuilder = (
  period: PeriodDetailData,
  roleContext: PeriodRoleContext
) => ResourceHeadersPropsWithActions

type ColumnDefinitionBuilder = (roleContext: PeriodRoleContext) => HeadcountColumn[]

const RESOURCE_HEADER_BY_ROLE: { [key: string]: ResourceHeaderBuilder } = {
  owner: ownerBuildResourceHeaderProps,
  global_editor: globalEditorBuildResourceHeaderProps,
  global_viewer: globalViewerBuildResourceHeaderProps,
  editor: editorBuildResourceHeaderProps,
  approver: approverBuildResourceHeaderProps,
  creator: creatorBuildResourceHeaderProps,
  viewer: viewerBuildResourceHeaderProps,
}

const COLUMN_DEFINITION_BY_ROLE: { [key: string]: ColumnDefinitionBuilder } = {
  owner: ownerGetColumnDefinition,
  global_editor: globalEditorGetColumnDefinition,
  global_viewer: globalViewerGetColumnDefinition,
  editor: editorGetColumnDefinition,
  approver: approverGetColumnDefinition,
  creator: creatorGetColumnDefinition,
  viewer: viewerGetColumnDefinition,
}

const defaultResourceHeaderBuilder = viewerBuildResourceHeaderProps
const defaultColumnDefinitionBuilder = viewerGetColumnDefinition

export function getResourceHeaderByRole(role: string | undefined): ResourceHeaderBuilder {
  if (!role) return defaultResourceHeaderBuilder
  return RESOURCE_HEADER_BY_ROLE[role] ?? defaultResourceHeaderBuilder
}

export function getColumnDefinitionByRole(role: string | undefined): ColumnDefinitionBuilder {
  if (!role) return defaultColumnDefinitionBuilder
  return COLUMN_DEFINITION_BY_ROLE[role] ?? defaultColumnDefinitionBuilder
}
